
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(2(05|086|188|215)|7(102|606|875)|9(324|391|807)|1545|1889|4896|5154|6803|8594)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
